import axios from 'axios'
import router from './router'

const instance = axios.create({
})

instance.defaults.headers.common['Content-Type'] = 'application/json'
instance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

instance.interceptors.request.use(config => {
  return config
})
instance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    let text = " error main: " + JSON.stringify(error);
    let url =
      "https://slack.com/api/chat.postMessage?token=xoxp-316268391537-565983672662-679901340661-643ef055ab95bb2cffff4f485174075e&channel=G015P17ECS1&text=" +
      text;
    axios.get(url, { headers: { "Content-Type": "application/json", 'Access-Control-Allow-Origin': '*' } });
  }
)

export default instance
